module.exports = __webpack_public_path__ + "img/top-bg.84100fed.png";